const Empty = ({ children }) => {
  return (
    <div className="grui py-20 text-center">{children || 'No results'}</div>
  )
}

export default Empty
